import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Board from './pages/Board';
import AuthPage from './pages/AuthPage';
import ProtectedRoutes from './utils/ProtectedRoutes';
import MobileRedirect from './utils/MobileRedirect';
import UserBoards from './pages/UserBoards';
import DashboardPage from './pages/DashboardPage';
import LandingPage from './pages/LandingPage';
import { useAuth } from './context/AuthContext';

function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <MobileRedirect>
          <Routes>
            <Route path="/" element={<Navigate to="/landing" />} />
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/login" element={<AuthPage />} />
            <Route element={<ProtectedRoutes />}>
              <Route path="/board/:boardId" element={<Board />} />
              <Route path="/user-boards" element={<UserBoards />} />
              <Route path="/dashboard" element={<DashboardPage />} />
            </Route>
          </Routes>
        </MobileRedirect>
      </BrowserRouter>
    </div>
  );
}

export default App;
